// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import AWS from 'aws-sdk';
import App from './App';
import router from './router';
import store from './store/index.js';
import ApiService from './services/api.service';
import Icon from 'vue-awesome/components/Icon';
import BootstrapVue from 'bootstrap-vue';
import VueCurrencyFilter from 'vue-currency-filter';
import VeeValidate from 'vee-validate';
import RuleFormatter from "@/services/utilities/ruleFormatter";
import VTextAreaRuleInput from "@/components/VTextAreaRuleInput";
import ToggleButton from 'vue-js-toggle-button';

Vue.config.productionTip = false;

// Bootstrap
Vue.use(BootstrapVue);

Vue.use(VueCurrencyFilter, {
  symbol: '$',
  thousandsSeparator: ',',
  fractionCount: 2,
  fractionSeparator: '.',
  symbolPosition: 'front',
  symbolSpacing: false
});

Vue.use(VeeValidate, { fieldsBagName: 'veeFields' });
Vue.use(ToggleButton);
VeeValidate.Validator.extend('isBigger', {
  getMessage: (field, parameters) => {
    var fieldName = parameters && parameters.length > 0 ? parameters[0] : "";
    return field + ' must be less than ' + fieldName;
  },
  validate: (value, [otherValue]) => value >= otherValue
},
  {
    hasTarget: true
  });

// FontAwesome icons
Vue.component('icon', Icon);

// Global Components
Vue.component("VTextAreaRuleInput", VTextAreaRuleInput);

// Filters
Vue.filter('capitalize', function (value) {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter('capitalizeRemoveHyphen', function (value) {
  if (!value) return '';
  value = value.toString();
  return value.replace('-', ' ').replace(/(?:^|\s)\S/g, a => a.toUpperCase()).replace(' ', '');
});

Vue.filter("yes-no", function (value) {
  return value ? "Yes" : "No";
});

Vue.filter("ruleToText", function (value) {
  if (!value || value.length === 0) return "";
  return RuleFormatter.formatRule(value[0]);
});

Vue.filter("snakeToTitleCase", function (value) {
  if (!value) return "";
  return value
    .toString()
    .split("_")
    .map(function (item) {
      return item.charAt(0).toUpperCase() + item.substring(1);
    })
    .join(" ");
});

ApiService.init();

AWS.config.region = process.env.AWS_REGION;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js